"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var colorTable = {
  warning: {
    text: '#B95656',
    background: 'rgba(185, 86, 86, 0.2)'
  },
  "default": {
    text: '#696969',
    background: '#F0F0F0'
  }
};
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: function root(props) {
      var _colorTable$props$col, _colorTable$props$col2, _colorTable$props$col3;
      return {
        borderRadius: 0,
        color: ((_colorTable$props$col = colorTable[props.colorVariant]) === null || _colorTable$props$col === void 0 ? void 0 : _colorTable$props$col.text) || '#696969',
        '&:hover': {
          backgroundColor: ((_colorTable$props$col2 = colorTable[props.colorVariant]) === null || _colorTable$props$col2 === void 0 ? void 0 : _colorTable$props$col2.background) || '#F0F0F0',
          color: ((_colorTable$props$col3 = colorTable[props.colorVariant]) === null || _colorTable$props$col3 === void 0 ? void 0 : _colorTable$props$col3.text) || '#696969'
        }
      };
    }
  };
}, {
  name: 'GhostButton'
});
exports.useStyles = useStyles;